export default {
  path: "customers",
  meta: { label: "Customer" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: () => import("@/views/onboardCustomer/index.vue"),
    },
    {
      path: "create",
      name: "CreateCustomer",
      meta: {
        label: "Onboard Customer",
        requiresAuth: true,
      },
      component: () => import("@/views/onboardCustomer/createCustomer.vue"),
    },
    {
      path: "edit/:id",
      name: "EditCustomer",
      meta: {
        label: "Edit Customer",
        requiresAuth: true,
      },
      component: () => import("@/views/onboardCustomer/editCustomer.vue"),
    },
    {
      path: "view/:id",
      name: "ViewCustomer",
      meta: {
        label: "View Customer",
        requiresAuth: true,
      },
      component: () => import("@/views/onboardCustomer/viewCustomer.vue"),
    },
    {
      path: "ticket/:id",
      name: "RaiseTicket",
      meta: {
        label: "Raise Ticket",
        requiresAuth: true,
      },
      component: () => import("@/views/onboardCustomer/raiseTicket.vue"),
    },
    {
      path: "createRequest/:id",
      name: "CreateRequest",
      meta: {
        label: "Create Request",
        requiresAuth: true,
      },
      component: () => import("@/views/onboardCustomer/createRequest.vue"),
    },
    {
      path: "myList/:id",
      name: "MyList",
      meta: {
        label: "Request List",
        requiresAuth: true,
      },
      component: () => import("@/views/onboardCustomer/requestList.vue"),
    },
    {
      path: "agentdetails/:id",
      name: "bookingDetails",
      meta: {
        label: "Agent Details",
        requiresAuth: true,
      },
      component: () => import("@/views/onboardCustomer/agentDetails.vue"),
    },
    {
      path: "bookingsucess/:id",
      name: "bookingSucess",
      meta: {
        label: "Booking Sucess",
        requiresAuth: true,
      },
      component: () => import("@/views/onboardCustomer/bookingSucess.vue"),
    },
  ],
};
